// extracted by mini-css-extract-plugin
export var container = "styles-module__container____FUEi";
export var embedFlex = "styles-module__embedFlex___dUZk6";
export var embedContainer = "styles-module__embedContainer___xPILZ";
export var embedVid = "styles-module__embedVid___hnEHI";
export var textContent = "styles-module__textContent___I07wf";
export var header = "styles-module__header___AkimO";
export var desc = "styles-module__desc___lmWGn";
export var divider = "styles-module__divider___ubOoY";
export var statsContainer = "styles-module__statsContainer___fyOSV";
export var stat = "styles-module__stat___IVAhV";
export var title = "styles-module__title___RPYAv";
export var subtitle = "styles-module__subtitle___EpwJo";